import { render, staticRenderFns } from "./ViewUserComponent.vue?vue&type=template&id=ed559aa2"
import script from "./ViewUserComponent.vue?vue&type=script&lang=js"
export * from "./ViewUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports